import {
  UserCheck,
  Boxes,
  Cpu,
  Wrench,
  Zap,
  MapPin,
} from "lucide-react";
import { ADVANTAGES } from "@/data/cybernet";

const ICONS = { UserCheck, Boxes, Cpu, Wrench, Zap, MapPin };

export const Advantages = () => {
  return (
    <section
      id="ventajas"
      data-testid="advantages-section"
      className="bg-white py-20 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-16 max-w-2xl">
          <div className="uppercase text-xs font-bold tracking-[0.25em] text-[#E10600] mb-4">
            — Ventajas
          </div>
          <h2 className="font-display font-black text-4xl sm:text-5xl tracking-tighter text-[#0A0A0A]">
            ¿Por qué elegir <span className="text-[#E10600]">CYBERNET</span>?
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E4E4E7] border border-[#E4E4E7] rounded-sm overflow-hidden">
          {ADVANTAGES.map((a) => {
            const Icon = ICONS[a.icon];
            return (
              <div
                key={a.title}
                data-testid={`advantage-${a.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="bg-white p-8 lg:p-10 group hover:bg-[#0A0A0A] transition-colors duration-300"
              >
                <div className="h-12 w-12 rounded-sm bg-[#E10600] flex items-center justify-center mb-6 transition-transform group-hover:rotate-6">
                  <Icon className="h-6 w-6 text-white" />
                </div>
                <h3 className="font-display font-bold text-xl text-[#0A0A0A] group-hover:text-white mb-3 transition-colors">
                  {a.title}
                </h3>
                <p className="text-sm text-[#52525B] group-hover:text-white/70 leading-relaxed transition-colors">
                  {a.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
